// 中文
const zh = {
    name:'费用录入',
    query1:"委托编号",
    query2:"主提单号",
    query3:"箱型箱量",
    query4:"件数",
    query5:"毛重",
    query6:"尺码",
    query7:"发票号",
    query8:"委托单位",
    query9:"卸货港",
    query10:"船名",
    query11:"航次",
    query12:"揽货人",
    query13:"ETD",
    query14:"付费方式",
    query15:"分提单号",
    query16:"目的地",
    query17:"装货港",
    query18:"备注",
    table1:'费用状态',
    table2:'应收费用名称',
    table3:'费用英文名称',
    table4:'客户类别',
    table5:'结算对象',
    table6:'单位标准',
    table7:'单价',
    table8:'数量',
    table9:'金额',
    table10:'不含税金额',
    table11:'税率',
    table12:'汇率',
    table13:'备注',
    table14:'币别',
    table15:'销项税额',
    table16:'销项金额',
    table17:'是否机密',
    table18:'是否垫付',
    table19:'禁开发票',
    table20:'录入人',
    table21:'录入日期',
    table22:'结算金额',
    table23:'已开票金额',
    table24:'对账编号',
    table25:'修改人',
    table26:'修改日期',
    table27:'发票申请金额',
    table28:'未开票金额',
    table29:'审核人',
    table30:'审核日期',
    table31:'大简云',
    table32:'应付费用名称',
    table33:'结算对象全称',
    table34:'申请金额',
    table35:'费用分组',
    table36:'账单号',
    table37:'不含税单价',
}

export default zh;


// WEBPACK FOOTER //
// ./src/i18n/config/zh.js